import {
  filter, forEach, get, isEmpty, values,
} from 'lodash';
import React, { useContext, useMemo } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import moment from 'moment';
import MenuFlashSaleCmp from '../components/MenuFlashSale';
import menuContext from '../contexts/menu';

export default function MenuFlashSale() {
  const { fridgeId: selectedFridgeId } = useParams() || {};
  const { menuCache } = useContext(menuContext);
  const { products: productDict, currentProviderCampaign, currentInventory } = menuCache || {};
  const fridgeInventory = get(currentInventory, selectedFridgeId, null);
  const d0002Campaigns = filter(get(currentProviderCampaign, [selectedFridgeId], {}), ['template', 'D0002']);

  const data = useMemo(() => {
    const result = {};

    forEach(d0002Campaigns, (campaign) => {
      const {
        parameters, products, start, end,
      } = campaign;
      const { Z, X } = parameters;

      if (!moment().isBetween(start, end)) return;

      if (!Z || !X) return;

      const removeDate = moment().utcOffset(8).add(X, 'hour').format('YYYY.MM.DD');

      forEach(products, (product) => {
        const {
          id, name, price, sellPrice,
        } = product;
        const item = get(productDict, id);
        const { provider: providerName } = item;
        const inventory = get(fridgeInventory, [id], 0);

        result[id] = {
          ...item,
          discountString: `${Z * 10}折`,
          inventory,
          name,
          price,
          providerName,
          removeDate,
          sellPrice,
        };
      });
    });
    return values(result);
  }, [d0002Campaigns, productDict, fridgeInventory]);

  return isEmpty(selectedFridgeId) ? (
    <Redirect to="/" replace />
  ) : (
    <MenuFlashSaleCmp data={data} />
  );
}
